export default __webpack_public_path__ + "static/media/yelp.3df62c43.svg";